/* ka-i18n（2026-10 海外対応）：英語などのページだけ #ka-i18n-dictionary の訳を使う。日本語のページでは辞書がないので、元の日本語をそのまま返す。 */
var kaT = (typeof window !== 'undefined' && window.kaT) || (function () {
  var dict;
  function load() { if (dict === undefined) { var el = document.getElementById('ka-i18n-dictionary'); if (!el) return null; try { dict = JSON.parse(el.textContent); } catch (e) { dict = null; } } return dict; }
  var f = function (key, ja) { var d = load(); return d && Object.prototype.hasOwnProperty.call(d, key) ? d[key] : ja; };
  f.on = function () { return !!load(); };
  f.val = function (v) { var d = load(); if (!d) return v; var m = d['kawaii.js.values_html']; if (typeof m === 'string') { try { m = d['kawaii.js.values_html'] = JSON.parse(m); } catch (e) { m = {}; } } return (m && m[v]) || v; };
  // 長い HTML の文は、日本語の部分だけを1つずつ訳に置き換える（言語ファイルの1つの値の長さに上限があるため）
  f.rep = function (s, pairs) { if (!load()) return s; for (var i = 0; i < pairs.length; i++) s = s.split(pairs[i][0]).join(f(pairs[i][1], pairs[i][0])); return s; };
  f.money = function (cents) { var c = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD'; return new Intl.NumberFormat('en-US', { style: 'currency', currency: c }).format(cents / 100); };
  window.kaT = f; return f;
})();
/*! Copyright (c) Safe As Milk. All rights reserved. */
import Cart from "cart-store";

import Cookies from "js-cookie";

import plugins from "cart-plugins";

import { debounce, formatMoney } from "utils";

class InteractiveCart extends HTMLElement {
    #cartDraw;
    #controlHeightAtValue;
    #resizeObserver;
    static #plugins={};
    connectedCallback() {
        this.id = this.getAttribute("id");
        this.form = this.querySelector("form");
        this.cart = Cart.getState().cart;
        this.freeShippingBar = this.querySelector("free-shipping-bar");
        this.#cartDraw = this.closest(".modal--cart");
        this.#controlHeightAtValue = null;
        this.#resizeObserver = null;
        if (this.getAttribute("height-control") && this.#cartDraw) {
            this.#controlHeightAtValue = Number(this.getAttribute("height-control"));
            this.#resizeObserver = new ResizeObserver(debounce(this.#onResize.bind(this), 100));
            this.#resizeObserver.observe(this.#cartDraw);
        }
        this.#render();
        this.unsubscribe = Cart.subscribe((state => {
            this.cart = state.cart;
            this.#render();
            this.#updateCartDiscounts();
            this.#updateCartTotal();
            this.#updateCartPoints();
            this.#updateFreeShipping();
        }));
    }
    disconnectedCallback() {
        this.unsubscribe();
        if (this.#resizeObserver) {
            this.#resizeObserver.disconnect();
            this.#resizeObserver = null;
        }
    }
    static registerPlugin(priority, fn) {
        if (InteractiveCart.#plugins[priority]) throw new Error(`Plugin with priority ${priority} is already registered`);
        InteractiveCart.#plugins[priority] = fn;
    }
    #onResize(entries) {
        entries.forEach((() => {
            const {parentElement: parentElement} = this;
            const parentElementComputedStyle = window.getComputedStyle(parentElement);
            const gap = Number(parentElementComputedStyle.getPropertyValue("row-gap").replace("px", ""));
            const parentElementTopPadding = Number(parentElementComputedStyle.getPropertyValue("padding-top").replace("px", ""));
            const siblingElements = Array.from(this.parentElement.querySelectorAll(".cart-draw__announcement, .cart-draw__head, .free-shipping-bar"));
            const cartControls = this.querySelector(".cart__controls");
            if (!cartControls) return;
            const blockedHeight = parentElementTopPadding + siblingElements.reduce(((total, element) => total + element.offsetHeight + gap), 0) + cartControls.offsetHeight;
            this.#cartDraw.classList.toggle("is-scrollable", this.#controlHeightAtValue > window.innerHeight - blockedHeight);
        }));
    }
    #render() {
        if (this.cart.item_count > 0) {
            this.#renderCart();
            Object.entries(InteractiveCart.#plugins).sort((([a], [b]) => a - b)).forEach((([, fn]) => {
                fn.call(this, Cart, this, this.cart);
            }));
        } else {
            this.#renderEmptyCart();
        }
    }
    #renderCart() {
        if (this.querySelector("cart-full")) return;
        const cartTemplate = document.getElementById("template-cart").content;
        const cartFragment = cartTemplate.cloneNode(true);
        const cartNote = cartFragment.querySelector("cart-note");
        const emptyCart = this.querySelector("cart-empty");
        if (emptyCart) {
            emptyCart.remove();
        }
        this.appendChild(cartFragment);
        if (cartNote) {
            cartNote.querySelector("cart-text-input").value = this.cart.note;
        }
        this.#updateCartDiscounts();
        this.#updateCartTotal();
        this.#updateCartPoints();
    }
    #renderEmptyCart() {
        if (this.querySelector("cart-empty")) return;
        const cartEmptyTemplate = document.getElementById("template-empty-cart").content;
        const cartEmptyFragment = cartEmptyTemplate.cloneNode(true);
        const cartFull = this.querySelector("cart-full");
        if (cartFull) {
            cartFull.remove();
        }
        this.appendChild(cartEmptyFragment);
    }
    #updateFreeShipping() {
        if (!this.freeShippingBar) return;
        this.freeShippingBar.setAttribute("value", this.cart.total_price);
    }
    #updateCartTotal() {
        const cartTotal = this.querySelector("cart-total");
        if (!cartTotal) return;
        cartTotal.innerHTML = formatMoney(this.cart.total_price, window.theme.money_total_price_format);
    }
    #updateCartPoints() {
        const pointsContainer = this.querySelector("[data-poingpong-cart-points]");
        const pointsValue = pointsContainer?.querySelector("[data-poingpong-cart-points-value]");
        const ratePercent = Number(pointsContainer?.dataset.poingpongRatePercent);
        if (!pointsValue || !Number.isFinite(ratePercent)) return;
        pointsValue.textContent = Math.floor((this.cart.total_price * ratePercent) / 10000);
    }
    #updateCartDiscounts() {
        const discountsContainer = this.querySelector("cart-discounts");
        if (!discountsContainer) return;
        const discounts = discountsContainer.querySelector("discount-list");
        const discountApplications = this.cart.cart_level_discount_applications;
        const discountItems = discountApplications.length > 0 && discountApplications[0].hasOwnProperty("discount_application") ? discountApplications.reduce(((items, {discount_application: {key: key, title: title, total_allocated_amount: amount}}) => {
            const newItems = items;
            const sameKeyItemIndex = newItems.findIndex((i => i.key === key));
            if (sameKeyItemIndex > -1) {
                newItems[sameKeyItemIndex].amount += amount;
                return newItems;
            }
            newItems.push({
                key: key,
                title: title,
                amount: amount
            });
            return newItems;
        }), []) : discountApplications.reduce(((items, {key: key, title: title, total_allocated_amount: amount}) => {
            items.push({
                key: key,
                title: title,
                amount: amount
            });
            return items;
        }), []);
        this.classList.toggle("has-cart-discounts", discountItems.length);
        const discountItemsString = JSON.stringify(discountItems);
        discounts.setAttribute("items", discountItemsString);
    }
}

customElements.define("interactive-cart", InteractiveCart);

class CartItems extends HTMLElement {
    connectedCallback() {
        this.items = Array.from(this.querySelectorAll("cart-item"));
        this.giftWrappingProductId = this.getAttribute("gift-wrapping-product-id");
        this.unsubscribe = Cart.subscribe((state => {
            this.items = this.items.reduce(((newItems, item) => {
                const key = item.getAttribute("key");
                const itemInCart = state.cart.items.find((i => i.key === key));
                if (!itemInCart) {
                    item.remove();
                    return newItems;
                }
                newItems.push(item);
                return newItems;
            }), []);
            const currentItemsKeys = this.items.map((item => item.key));
            const newItems = [];
            state.cart.items.forEach(((item, i) => {
                if (!currentItemsKeys.includes(item.key)) {
                    const newCartItem = CartItems.#createCartItem(item);
                    if (i === 0) {
                        this.prepend(newCartItem);
                    } else {
                        newItems[i - 1].after(newCartItem);
                    }
                    newItems.push(newCartItem);
                } else {
                    const oldItem = this.items.find((j => j.key === item.key));
                    if (currentItemsKeys.indexOf(oldItem.key) !== i) {
                        if (i === 0) {
                            this.prepend(oldItem);
                        } else {
                            newItems[i - 1].after(oldItem);
                        }
                    }
                    newItems.push(oldItem);
                }
            }));
            this.items = newItems;
        }));
    }
    disconnectedCallback() {
        this.unsubscribe();
    }
    static #createCartItem(item) {
        const cartItemTemplate = document.getElementById("template-cart-item").content;
        const cartItemFragment = cartItemTemplate.cloneNode(true);
        const cartItem = cartItemFragment.querySelector("cart-item");
        cartItem.setAttribute("key", item.key);
        return cartItem;
    }
}

customElements.define("cart-items", CartItems);

class CartItem extends HTMLElement {
    #boundRemoveProduct;
    #debouncedChangeQuantity;
    #isRendered;
    static #plugins={};
    constructor() {
        super();
        this.#debouncedChangeQuantity = debounce(this.#changeQuantity.bind(this), 250);
        this.#boundRemoveProduct = this.#removeProduct.bind(this);
    }
    connectedCallback() {
        this.key = this.getAttribute("key");
        this.item = Cart.getState().cart.items.find((item => item.key === this.key));
        if (!this.item) return;
        if (this.item.variant_id === Cart.getState().giftWrapping.productId) {
            this.giftWrappingItem = true;
            this.noQuantityInput = true;
            this.noLinks = true;
            this.giftWrappingMessageEnabled = Cart.getState().giftWrapping.giftMessageEnabled;
            this.giftWrappingMessage = Cart.getState().cart.attributes["gift-wrapping-message"] || "";
        }
        this.image = this.querySelector("cart-item-image-container img");
        this.imageContainerRatio = this.getAttribute("image-container-ratio").trim();
        this.imageFit = this.hasAttribute("image-fit");
        this.details = this.querySelector("cart-item-details");
        this.#isRendered = this.hasAttribute("rendered");
        if (!this.#isRendered) {
            this.#render();
        }
        this.quantity = this.querySelector("quantity-input");
        this.removeItemButton = this.querySelector("[cart-item-remove");
        setTimeout((() => {
            if (this.quantity) this.quantity.addEventListener("update", this.#debouncedChangeQuantity);
            if (this.removeItemButton) this.removeItemButton.addEventListener("click", this.#boundRemoveProduct);
        }));
        this.unsubscribe = Cart.subscribe(((state, prevState) => {
            if (state.lineItemsBeingUpdated.length > 0) {
                this.#renderError();
            }
            if (state.lineItemsBeingUpdated.includes(this.key)) {
                this.#toggleSpinner(true);
            } else {
                const newItem = state.cart.items.find((item => item.key === this.key));
                if (newItem && prevState.lineItemsBeingUpdated.includes(this.key)) {
                    this.#toggleSpinner(false);
                }
                if (!state.lineItemsBeingUpdated.includes(this.key)) {
                    if (this.quantity && this.quantity.value !== newItem.quantity) {
                        this.quantity.value = newItem.quantity;
                    } else {
                        const quantityDisplay = this.querySelector("quantity-display");
                        if (quantityDisplay) {
                            quantityDisplay.innerHTML = newItem.quantity;
                        }
                    }
                }
                this.item = newItem;
                this.#clearTotalPrice();
                this.#renderTotalPriceAndDiscounts();
                this.#updateLinePoints();
                this.#runPostRenderFunctions();
            }
        }));
        setTimeout((() => this.#runPostRenderFunctions));
    }
    disconnectedCallback() {
        if (this.unsubscribe) this.unsubscribe();
        if (this.quantity) this.quantity.removeEventListener("update", this.#debouncedChangeQuantity);
        if (this.removeItemButton) this.removeItemButton.removeEventListener("click", this.#boundRemoveProduct);
    }
    static registerPlugin(priority, fn) {
        if (CartItem.#plugins[priority]) throw new Error(`Plugin with priority ${priority} is already registered`);
        CartItem.#plugins[priority] = fn;
    }
    #runPostRenderFunctions() {
        Object.entries(CartItem.#plugins).sort((([a], [b]) => a - b)).forEach((([, fn]) => {
            fn.call(this, Cart, this, this.item);
        }));
    }
    #render() {
        this.querySelectorAll("a[cart-item-url]").forEach((link => {
            if (this.noLinks) {
                const div = document.createElement("div");
                if (link.hasAttribute("class")) {
                    div.setAttribute("class", link.getAttribute("class"));
                }
                if (link.hasAttribute("style")) {
                    div.setAttribute("style", link.getAttribute("style"));
                }
                div.innerHTML = link.innerHTML;
                link.replaceWith(div);
                this.image = this.querySelector("cart-item-image-container img");
            } else {
                link.setAttribute("href", this.item.url);
            }
        }));
        this.#setImage();
        if (this.imageContainerRatio === "natural") {
            this.image.closest(".o-ratio").style.paddingBottom = `${1 / (this.item.featured_image ? this.item.featured_image.aspect_ratio : 1) * 100}%`;
        } else {
            this.image.closest(".o-ratio").style.paddingBottom = null;
        }
        this.#updateSkeleton();
        this.querySelector("cart-item-title").innerHTML = this.item.product_title;
        const metaItemTemplate = document.getElementById("template-cart-item-meta").content;
        const vendor = this.querySelector("cart-item-vendor");
        if (vendor) {
            vendor.appendChild(metaItemTemplate.cloneNode(true));
            vendor.querySelector("property-value").innerHTML = this.item.vendor;
        }
        if (this.item.variant_title && !this.item.variant_title.includes("Default")) {
            const defaultProperty = this.querySelector("cart-item-default-property");
            defaultProperty.appendChild(metaItemTemplate.cloneNode(true));
            defaultProperty.querySelector("property-value").innerHTML = this.item.variant_title;
        }
        if (Object.keys(this.item.properties || {}).length > 0) {
            const propertyItemTemplate = document.getElementById("template-cart-item-property").content;
            const properties = this.querySelector("cart-item-properties");
            Object.entries(this.item.properties).forEach((([name, value]) => {
                if (value !== "" && name.slice(0, 1) !== "_") {
                    const propertyTemplate = propertyItemTemplate.cloneNode(true);
                    let propertyName = name;
                    if (this.item.gift_card && name === "Recipient email") {
                        propertyName = window.theme.localize("GIFT_CARD_RECIPIENT_EMAIL");
                    } else if (this.item.gift_card && name === "Recipient name") {
                        propertyName = window.theme.localize("GIFT_CARD_RECIPIENT_NAME");
                    } else if (this.item.gift_card && name === "Recipient message") {
                        propertyName = window.theme.localize("GIFT_CARD_RECIPIENT_MESSAGE");
                    } else if (this.item.gift_card && name === "Recipient send on") {
                        propertyName = window.theme.localize("GIFT_CARD_RECIPIENT_SEND_ON");
                    }
                    propertyTemplate.querySelector("property-name").innerHTML = propertyName;
                    propertyTemplate.querySelector("property-value").innerHTML = value.includes("/uploads/") ? `<a href="${value}">${value.split("/").pop()}</a>` : value;
                    properties.appendChild(propertyTemplate);
                }
            }));
        }
        if (this.item.selling_plan_allocation) {
            const sellingPlanAllocation = this.querySelector("cart-item-selling-plan-allocation");
            sellingPlanAllocation.appendChild(metaItemTemplate.cloneNode(true));
            sellingPlanAllocation.querySelector("property-value").innerHTML = `${this.item.selling_plan_allocation.selling_plan.name}${this.item.selling_plan_allocation.compare_at_price && this.item.selling_plan_allocation.compare_at_price !== this.item.selling_plan_allocation.price ? ` (-${Math.round((1 - this.item.selling_plan_allocation.price / this.item.selling_plan_allocation.compare_at_price) * 100)}%)` : ""}`;
        }
        const sku = this.querySelector("cart-item-sku");
        if (sku && this.item.sku) {
            sku.appendChild(metaItemTemplate.cloneNode(true));
            sku.querySelector("property-value").innerHTML = this.item.sku;
        }
        if (this.item.unit_price_measurement) {
            const itemUnitPrice = this.querySelector("cart-item-unit-price");
            const unitPriceTemplate = document.getElementById("template-unit-price").content;
            itemUnitPrice.appendChild(unitPriceTemplate.cloneNode(true));
            const baseUnit = `${this.item.unit_price_measurement.reference_value !== 1 ? this.item.unit_price_measurement.reference_value : ""}${this.item.unit_price_measurement.reference_unit}`;
            itemUnitPrice.querySelector("unit-price").innerHTML = formatMoney(this.item.unit_price, window.theme.money_format);
            itemUnitPrice.querySelector("base-unit").innerHTML = baseUnit;
        }
        if (this.giftWrappingItem && this.giftWrappingMessageEnabled) {
            const giftWrappingMessageTemplate = document.getElementById("template-cart-gift-wrapping-message").content;
            this.querySelector("cart-item-micro-copy").appendChild(giftWrappingMessageTemplate.cloneNode(true));
            this.classList.add("cart-item--full-details");
            this.querySelector("cart-text-input").value = this.giftWrappingMessage;
        }
        if (this.noQuantityInput) {
            const quantityDisplay = document.createElement("quantity-display");
            quantityDisplay.classList.add("cart-item__qty-display");
            quantityDisplay.innerHTML = this.item.quantity;
            this.querySelector("cart-item-quantity").appendChild(quantityDisplay);
        } else {
            const quantityInputTemplate = document.getElementById("template-quantity-input").content;
            const quantityElement = quantityInputTemplate.cloneNode(true);
            this.quantity = quantityElement.querySelector("quantity-input");
            const quantityInput = quantityElement.querySelector('input[type="number"]');
            quantityInput.setAttribute("id", `updates_${this.item.key}`);
            quantityInput.setAttribute("name", `updates[]`);
            this.querySelector("cart-item-quantity").appendChild(this.quantity);
            setTimeout((() => {
                this.quantity.value = this.item.quantity;
            }));
            this.removeItemButton = this.querySelector("button[cart-item-remove]");
        }
        this.#renderTotalPriceAndDiscounts();
        this.#updateLinePoints();
        this.setAttribute("rendered", "");
    }
    #setImage(srcsetWidths = [ 120, 240, 360, 480 ]) {
        if (!this.image) return;
        const imageData = this.item.featured_image;
        if (imageData && imageData.url) {
            const {width: width, height: height, url: url} = imageData;
            const imageContainerRatio = this.imageContainerRatio !== "natural" ? this.imageContainerRatio.split(":").reduce(((ratio, value) => ratio !== 0 ? value / ratio : value), 0) : null;
            const aspectRatio = width / height;
            const uncroppedImage = this.imageContainerRatio === "natural" || imageContainerRatio && this.imageFit;
            let masterWidth = width;
            let masterHeight = height;
            if (!uncroppedImage) {
                masterHeight = Math.round(masterWidth * imageContainerRatio);
                if (masterHeight > height) {
                    masterHeight = height;
                    masterWidth = Math.round(masterHeight / imageContainerRatio);
                }
            }
            const srcset = srcsetWidths.reduce(((srcSet, srcWidth) => {
                const srcHeight = Math.round(uncroppedImage ? srcWidth / aspectRatio : srcWidth * imageContainerRatio);
                if (srcWidth > masterWidth || srcHeight > masterHeight) return srcSet;
                return `${srcSet}${url}${url.includes("?") ? "&" : "?"}width=${srcWidth}${!uncroppedImage ? `&height=${srcHeight}&crop=center` : ""} ${srcWidth}w ${srcHeight}h, `;
            }), "");
            const masterSrc = !uncroppedImage ? `${url}${url.includes("?") ? "&" : "?"}width=${masterWidth}&height=${masterHeight}&crop=center` : url;
            this.image.setAttribute("src", masterSrc);
            this.image.setAttribute("srcset", srcset);
            this.image.setAttribute("width", masterWidth);
            this.image.setAttribute("height", masterHeight);
        }
        this.image.setAttribute("alt", `Image for ${this.item.title}`);
    }
    #updateSkeleton() {
        if (!this.image) return;
        const skeleton = this.image.previousElementSibling && this.image.previousElementSibling.tagName.toLowerCase() === "image-skeleton" ? this.image.previousElementSibling : null;
        if (skeleton) {
            const svg = skeleton.querySelector("svg");
            const rect = svg.querySelector("rect");
            const width = this.image.getAttribute("width");
            const height = this.image.getAttribute("height");
            skeleton.setAttribute("aria-label", `Loading image for ${this.item.title}`);
            svg.setAttribute("width", width);
            svg.setAttribute("height", height);
            svg.setAttribute("viewBox", `0 0 ${width} ${height}`);
            rect.setAttribute("width", width);
            rect.setAttribute("height", height);
        }
    }
    #toggleSpinner(visible = true) {
        if (visible) {
            this.#clearTotalPrice();
            const quantityInputTemplate = document.getElementById("template-spinner").content;
            this.querySelector("cart-item-spinner").appendChild(quantityInputTemplate.cloneNode(true));
        } else {
            this.querySelector("cart-item-spinner").innerHTML = "";
        }
    }
    #clearTotalPrice() {
        const priceContainer = this.querySelector("cart-item-original-line-price").parentElement;
        if (priceContainer) {
            const priceContainerWidth = priceContainer.offsetWidth;
            const priceContainerHeight = priceContainer.offsetHeight;
            priceContainer.style.width = `${priceContainerWidth}px`;
            priceContainer.style.height = `${priceContainerHeight}px`;
        }
        this.querySelector("cart-item-original-line-price").innerHTML = "";
        this.querySelector("cart-item-final-line-price").innerHTML = "";
    }
    #renderTotalPriceAndDiscounts() {
        const originalLinePrice = this.querySelector("cart-item-original-line-price");
        const finalLinePrice = this.querySelector("cart-item-final-line-price");
        const priceTemplate = document.getElementById("template-price").content;
        if (this.item.original_line_price !== this.item.final_line_price) {
            originalLinePrice.appendChild(priceTemplate.cloneNode(true));
            originalLinePrice.querySelector(".price").classList.add("price--original");
            originalLinePrice.querySelector("money-amount").innerHTML = formatMoney(this.item.original_line_price, window.theme.money_format);
            finalLinePrice.appendChild(priceTemplate.cloneNode(true));
            finalLinePrice.querySelector(".price").classList.add("price--sale");
            finalLinePrice.querySelector("money-amount").innerHTML = formatMoney(this.item.final_line_price, window.theme.money_format);
        } else {
            originalLinePrice.appendChild(priceTemplate.cloneNode(true));
            originalLinePrice.querySelector("money-amount").innerHTML = formatMoney(this.item.final_line_price, window.theme.money_format);
        }
        const discountsContainer = this.querySelector("cart-item-discounts");
        const discounts = discountsContainer.querySelector("discount-list");
        const discountItems = JSON.stringify(this.item.line_level_discount_allocations.reduce(((items, {amount: amount, discount_application: {key: key, title: title}}) => {
            items.push({
                key: key,
                title: title,
                amount: amount
            });
            return items;
        }), []));
        discounts.setAttribute("items", discountItems);
        this.classList.toggle("has-discounts", this.item.line_level_discount_allocations.length > 0);
        const priceContainer = this.querySelector("cart-item-original-line-price").parentElement;
        if (priceContainer) {
            priceContainer.style.width = "";
            priceContainer.style.height = "";
        }
    }
    #updateLinePoints() {
        const pointsContainer = this.querySelector("[data-poingpong-line-points]");
        const pointsValue = pointsContainer?.querySelector("[data-poingpong-line-points-value]");
        const ratePercent = Number(pointsContainer?.dataset.poingpongRatePercent);
        if (!pointsContainer || !pointsValue || !Number.isFinite(ratePercent)) return;
        pointsValue.textContent = Math.floor((this.item.final_line_price * ratePercent) / 10000);
        pointsContainer.hidden = false;
    }
    #renderError(errorText = "") {
        const errorContainer = this.querySelector("cart-item-errors");
        this.classList.toggle("has-errors", errorText);
        errorContainer.innerHTML = `<div class="errors qty-error u-small">${errorText}</div>`;
    }
    async #changeQuantity() {
        if (!this.key) return;
        try {
            await Cart.change({
                id: this.key,
                quantity: this.quantity.value
            });
        } catch (e) {
            if (e.name && e.name === "AbortError") return;
            this.#renderError(e.message);
        }
    }
    async #removeProduct(e) {
        if (!this.key) return;
        e.preventDefault();
        if (this.giftWrappingItem) {
            await Cart.setGiftWrapping(false);
        } else {
            await Cart.change({
                id: this.key,
                quantity: 0
            });
        }
    }
}

customElements.define("cart-item", CartItem);

class DiscountList extends HTMLElement {
    constructor() {
        super();
        this.items = JSON.parse(this.getAttribute("items") || "[]");
    }
    static get observedAttributes() {
        return [ "items" ];
    }
    attributeChangedCallback(_, oldVal, newVal) {
        if (oldVal !== newVal) {
            this.items = JSON.parse(newVal);
            this.#renderDiscounts();
        }
    }
    #renderDiscounts() {
        this.innerHTML = "";
        if (this.items.length > 0) {
            const discountsList = document.createElement("ul");
            discountsList.classList.add("discounts");
            this.appendChild(discountsList);
            this.items.forEach((item => {
                const discount = document.createElement("li");
                discount.classList.add("discount");
                discountsList.appendChild(discount);
                const discountTemplate = document.getElementById("template-discount-item").content;
                discount.appendChild(discountTemplate.cloneNode(true));
                discount.querySelector("discount-title").innerHTML = item.title;
                if (item.amount > 0) {
                    discount.querySelector("discount-amount").innerHTML = formatMoney(item.amount, window.theme.money_format);
                }
            }));
        }
    }
}

customElements.define("discount-list", DiscountList);

class CartTextInput extends HTMLElement {
    #function;
    #spinnerTemplate;
    #status;
    #text;
    #updated;
    #updatedHTML;
    #updating;
    async connectedCallback() {
        this.#text = this.querySelector('textarea, input[type="text"]');
        this.#status = this.querySelector("cart-text-input-status");
        this.#updatedHTML = '<div class="is-saved">&checkmark;</div>';
        this.#updating = false;
        this.#updated = false;
        this.#spinnerTemplate = document.getElementById("template-spinner").content;
        this.#function = () => {};
        this.#text.addEventListener("input", this.#function);
    }
    disconnectedCallback() {
        this.#text.removeEventListener("input", this.#function);
    }
    set updating(isUpdating) {
        this.#updated = false;
        this.#updating = isUpdating;
        if (isUpdating) {
            this.#status.innerHTML = "";
            this.#status.appendChild(this.#spinnerTemplate.cloneNode(true));
        }
    }
    get updating() {
        return this.#updating;
    }
    set updated(isUpdated) {
        this.#updating = false;
        this.#updated = isUpdated;
        if (isUpdated) {
            this.#status.innerHTML = this.#updatedHTML;
        }
    }
    get updated() {
        return this.#updated;
    }
    set value(value) {
        this.#text.value = value;
    }
    get value() {
        return this.#text.value;
    }
    set updatedHTML(html) {
        this.#updatedHTML = html;
    }
    get updatedHTML() {
        return this.#updatedHTML;
    }
    set function(f) {
        this.#text.removeEventListener("input", this.#function);
        this.#function = debounce(f, 1e3);
        this.#text.addEventListener("input", this.#function);
    }
    get function() {
        return this.#function;
    }
}

customElements.define("cart-text-input", CartTextInput);

class CartGiftWrappingMessage extends HTMLElement {
    #cartTextInput;
    async connectedCallback() {
        this.#cartTextInput = this.querySelector("cart-text-input");
        setTimeout((() => {
            this.#cartTextInput.function = CartGiftWrappingMessage.#updateMessage.bind(this);
        }));
        this.unsubscribe = Cart.subscribe(((state, prevState) => {
            if (state.giftWrapping.messageBeingUpdated) {
                this.#cartTextInput.updating = true;
            } else if (prevState.giftWrapping.messageBeingUpdated) {
                this.#cartTextInput.updated = true;
            }
        }));
    }
    disconnectedCallback() {
        this.unsubscribe();
    }
    static async #updateMessage(e) {
        try {
            await Cart.updateGiftWrappingMessage(e.target.value);
        } catch (error) {
            if (error.name && error.name === "AbortError") return;
            console.log(e);
        }
    }
}

customElements.define("cart-gift-wrapping-message", CartGiftWrappingMessage);

class CartNote extends HTMLElement {
    #cartTextInput;
    connectedCallback() {
        this.#cartTextInput = this.querySelector("cart-text-input");
        setTimeout((() => {
            this.#cartTextInput.function = CartNote.#updateNote.bind(this);
        }));
        this.unsubscribe = Cart.subscribe(((state, prevState) => {
            if (state.noteBeingUpdated) {
                this.#cartTextInput.updating = true;
            } else if (prevState.noteBeingUpdated) {
                this.#cartTextInput.updated = true;
            }
        }));
    }
    disconnectedCallback() {
        this.unsubscribe();
    }
    static async #updateNote(e) {
        try {
            await Cart.updateCartNote(e.target.value);
        } catch (error) {
            if (error.name && error.name === "AbortError") return;
            console.log(e);
        }
    }
}

customElements.define("cart-note", CartNote);

class CartTerms extends HTMLElement {
    #boundInputChange;
    #boundValidateForm;
    connectedCallback() {
        this.form = this.closest("form");
        this.input = this.querySelector('input[type="checkbox"]');
        this.error = this.querySelector("cart-terms-error");
        this.#boundValidateForm = this.#validateForm.bind(this);
        this.#boundInputChange = this.#inputChange.bind(this);
        setTimeout((() => {
            if (Cookies.get("cart_order_terms") === "accepted") {
                this.input.checked = true;
            }
            this.form.addEventListener("submit", this.#boundValidateForm);
            this.input.addEventListener("change", this.#boundInputChange);
        }));
    }
    disconnectedCallback() {
        this.form.removeEventListener("submit", this.#boundValidateForm);
        this.input.removeEventListener("change", this.#boundInputChange);
    }
    #validateForm(e) {
        if (!this.input.checked) {
            e.preventDefault();
            this.#toggleError(true);
        }
    }
    #inputChange({target: {checked: checked}}) {
        if (checked) {
            this.#toggleError(false);
        }
        Cookies.set("cart_order_terms", checked ? "accepted" : "", {
            secure: true,
            SameSite: "None"
        });
    }
    #toggleError(visible = true) {
        if (visible) {
            this.error.removeAttribute("hidden");
            this.error.classList.add("is-active");
        } else {
            this.error.classList.remove("is-active");
            this.error.setAttribute("hidden", "");
        }
    }
}

customElements.define("cart-terms", CartTerms);

class CartNotification extends HTMLElement {
    #imagePlaceholder;
    connectedCallback() {
        this.image = this.querySelector("cart-item-image-container img");
        this.#imagePlaceholder = this.image.cloneNode();
        this.imageContainerRatio = this.querySelector(".cart-item").getAttribute("image-container-ratio").trim();
        this.imageFit = this.querySelector(".cart-item").hasAttribute("image-fit");
        this.item = Cart.getState().latestAddedProduct;
        this.unsubscribe = Cart.subscribe((state => {
            if (state.latestAddedProduct) {
                this.item = state.latestAddedProduct;
                this.#render();
            } else {
                this.item = null;
            }
        }));
    }
    disconnectedCallback() {
        this.unsubscribe();
    }
    #render() {
        if (!this.item) return;
        this.#setImage();
        if (this.imageContainerRatio === "natural") {
            this.image.closest(".o-ratio").style.paddingBottom = `${1 / (this.item.featured_image ? this.item.featured_image.aspect_ratio : 1) * 100}%`;
        } else {
            this.image.closest(".o-ratio").style.paddingBottom = null;
        }
        this.#updateSkeleton();
        this.querySelector("cart-item-title").innerHTML = this.item.product_title;
        const metaItemTemplate = document.getElementById("template-cart-item-meta").content;
        if (this.item.variant_title && !this.item.variant_title.includes("Default")) {
            const defaultProperty = this.querySelector("cart-item-default-property");
            defaultProperty.innerHTML = "";
            defaultProperty.appendChild(metaItemTemplate.cloneNode(true));
            defaultProperty.querySelector("property-value").innerHTML = this.item.variant_title;
        }
        const vendor = this.querySelector("cart-item-vendor");
        if (vendor) {
            vendor.innerHTML = "";
            vendor.appendChild(metaItemTemplate.cloneNode(true));
            vendor.querySelector("property-value").innerHTML = this.item.vendor;
        }
    }
    #setImage(srcsetWidths = [ 120, 240, 360, 480 ]) {
        if (!this.image) return;
        const imageData = this.item.featured_image;
        if (imageData && imageData.url) {
            const {width: width, height: height, url: url} = imageData;
            const imageContainerRatio = this.imageContainerRatio !== "natural" ? this.imageContainerRatio.split(":").reduce(((ratio, value) => ratio !== 0 ? value / ratio : value), 0) : null;
            const aspectRatio = width / height;
            const uncroppedImage = this.imageContainerRatio === "natural" || imageContainerRatio && this.imageFit;
            let masterWidth = width;
            let masterHeight = height;
            if (!uncroppedImage) {
                masterHeight = Math.round(masterWidth * imageContainerRatio);
                if (masterHeight > height) {
                    masterHeight = height;
                    masterWidth = Math.round(masterHeight / imageContainerRatio);
                }
            }
            const srcset = srcsetWidths.reduce(((srcSet, srcWidth) => {
                const srcHeight = Math.round(uncroppedImage ? srcWidth / aspectRatio : srcWidth * imageContainerRatio);
                if (srcWidth > masterWidth || srcHeight > masterHeight) return srcSet;
                return `${srcSet}${url}${url.includes("?") ? "&" : "?"}width=${srcWidth}${!uncroppedImage ? `&height=${srcHeight}&crop=center` : ""} ${srcWidth}w ${srcHeight}h, `;
            }), "");
            const masterSrc = !uncroppedImage ? `${url}${url.includes("?") ? "&" : "?"}width=${masterWidth}&height=${masterHeight}&crop=center` : url;
            this.image.setAttribute("src", masterSrc);
            this.image.setAttribute("srcset", srcset);
            this.image.setAttribute("width", masterWidth);
            this.image.setAttribute("height", masterHeight);
        } else {
            this.image.setAttribute("src", this.#imagePlaceholder.getAttribute("src"));
            this.image.setAttribute("srcset", this.#imagePlaceholder.getAttribute("srcset"));
            this.image.setAttribute("width", this.#imagePlaceholder.getAttribute("width"));
            this.image.setAttribute("height", this.#imagePlaceholder.getAttribute("height"));
        }
        this.image.setAttribute("alt", `Image for ${this.item.title}`);
    }
    #updateSkeleton() {
        if (!this.image) return;
        const skeleton = this.image.nextElementSibling && this.image.nextElementSibling.tagName.toLowerCase() === "image-skeleton" ? this.image.nextElementSibling : null;
        if (skeleton) {
            const svg = skeleton.querySelector("svg");
            const rect = svg.querySelector("rect");
            const width = this.image.getAttribute("width");
            const height = this.image.getAttribute("height");
            skeleton.setAttribute("aria-label", `Loading image for ${this.item.title}`);
            svg.setAttribute("width", width);
            svg.setAttribute("height", height);
            svg.setAttribute("viewBox", `0 0 ${width} ${height}`);
            rect.setAttribute("width", width);
            rect.setAttribute("height", height);
        }
    }
}

customElements.define("cart-notification", CartNotification);

class CartQuantityInfo extends HTMLElement {
    constructor() {
        super();
        this.itemsCount = this.querySelector("items-count");
        this.infoContent = this.querySelector("info-content");
    }
    connectedCallback() {
        this.unsubscribe = Cart.subscribe((state => {
            const artworkCount = state.cart.items.reduce((count, item) => item.properties?._dn13_gift_role === 'fee' ? count : count + item.quantity, 0);
            if (artworkCount > 0) {
                this.removeAttribute("hidden");
                if (artworkCount === 1) {
                    this.infoContent.innerHTML = window.theme.localize("CART_ITEM_SINGULAR");
                } else {
                    this.infoContent.innerHTML = window.theme.localize("CART_ITEM_PLURAL");
                }
            } else {
                this.setAttribute("hidden", "");
            }
            this.itemsCount.textContent = artworkCount.toString();
        }));
    }
    disconnectedCallback() {
        this.unsubscribe();
    }
}

customElements.define("cart-quantity-info", CartQuantityInfo);

class CartGiftWrappingBanner extends HTMLElement {
    #boundEnable;
    constructor() {
        super();
        this.#boundEnable = this.#enable.bind(this);
    }
    connectedCallback() {
        this.trigger = this.querySelector("button");
        this.stagedAction = this.querySelector("staged-action");
        const giftWrappingEnabled = Boolean(Cart.getState().cart.attributes["gift-wrapping"] === "false" ? false : Cart.getState().cart.attributes["gift-wrapping"]);
        if (giftWrappingEnabled) {
            this.setAttribute("hidden", "");
        }
        this.unsubscribe = Cart.subscribe((state => {
            const giftWrappingSet = Boolean(state.cart.attributes["gift-wrapping"]);
            if (!giftWrappingSet) {
                this.removeAttribute("hidden");
            }
        }));
        this.trigger.addEventListener("click", this.#boundEnable);
    }
    disconnectedCallback() {
        this.unsubscribe();
        this.trigger.removeEventListener("click", this.#boundEnable);
    }
    async #enable(e) {
        e.preventDefault();
        try {
            if (this.stagedAction) await this.stagedAction.setState("DOING");
            await Cart.setGiftWrapping();
            if (this.stagedAction) await this.stagedAction.setState("DONE");
            this.setAttribute("hidden", "");
        } catch (error) {
            console.log(error);
            if (this.stagedAction) await this.stagedAction.setState("IDLE");
        }
    }
}

customElements.define("cart-gift-wrapping-banner", CartGiftWrappingBanner);

plugins.map((({functions: functions}) => functions)).forEach((pluginFunctions => {
    Object.entries(pluginFunctions).forEach((([componentType, functions]) => {
        if (componentType === "interactive-cart") {
            Object.entries(functions).forEach((([priority, fn]) => {
                InteractiveCart.registerPlugin(priority, fn);
            }));
        }
        if (componentType === "cart-item") {
            Object.entries(functions).forEach((([priority, fn]) => {
                CartItem.registerPlugin(priority, fn);
            }));
        }
    }));
}));

(function (root, factory) {
  const api = factory();
  root.KaGiftCore = api;
  if (typeof module === 'object' && module.exports) module.exports = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';

  const TOKEN = '_dn13_gift_token';
  const ROLE = '_dn13_gift_role';
  const FEE_TYPE = '_dn13_gift_fee_type';

  function props(item) {
    return item && item.properties && typeof item.properties === 'object'
      ? item.properties
      : {};
  }

  function tagged(item, role) {
    const properties = props(item);
    return Boolean(properties[TOKEN]) && properties[ROLE] === role;
  }

  function error(code, message, token, extra) {
    return Object.assign({ code, message, token }, extra || {});
  }

  function hasPaidWrapping(properties) {
    const value = properties['ラッピング'];
    if (typeof value !== 'string' || !value.trim()) return false;
    return !/^(?:(?:ラッピング)?(?:なし|無し|不要)|none)$|無料/i.test(value.trim());
  }

  function requiredFeeTypes(properties) {
    const required = [];
    if (hasPaidWrapping(properties)) required.push('wrapping');
    if (properties['のし'] === 'アートのし') required.push('art-noshi');
    return required;
  }

  function analyze(items) {
    const buckets = new Map();
    const orphanFees = [];
    const errors = [];

    for (const item of items || []) {
      if (!tagged(item, 'main') && !tagged(item, 'fee')) {
        if (requiredFeeTypes(props(item)).length > 0) {
          errors.push(error('missing-main-tag', kaT('kawaii.js.cart_components_cart_err_missing_main_html', '有料ギフトを選択した作品の紐づけ情報がありません。カートをご確認ください。'), props(item)[TOKEN], {
            key: item && item.key
          }));
        }
        continue;
      }
      const token = props(item)[TOKEN];
      if (!buckets.has(token)) buckets.set(token, { mains: [], fees: [] });
      buckets.get(token)[tagged(item, 'main') ? 'mains' : 'fees'].push(item);
    }

    const groups = [];
    for (const [token, bucket] of buckets) {
      if (bucket.mains.length === 0) {
        orphanFees.push(...bucket.fees);
        for (const fee of bucket.fees) {
          errors.push(error('orphan-fee', kaT('kawaii.js.cart_components_cart_err_orphan_html', '作品に紐づかないギフト料金があります。カートをご確認ください。'), token, {
            key: fee.key,
            feeType: props(fee)[FEE_TYPE]
          }));
        }
        continue;
      }

      const main = bucket.mains[0];
      groups.push({ main, fees: bucket.fees.slice() });

      if (bucket.mains.length > 1) {
        errors.push(error('multiple-main', kaT('kawaii.js.cart_components_cart_err_multiple_html', '同じギフト情報に複数の作品が紐づいています。カートをご確認ください。'), token));
      }

      const feesByType = new Map();
      for (const fee of bucket.fees) {
        const feeType = props(fee)[FEE_TYPE];
        if (!feesByType.has(feeType)) feesByType.set(feeType, []);
        feesByType.get(feeType).push(fee);
        if (fee.quantity !== main.quantity) {
          errors.push(error('quantity-mismatch', kaT('kawaii.js.cart_components_cart_err_quantity_html', '作品とギフト料金の数量が一致していません。カートをご確認ください。'), token, {
            key: fee.key,
            feeType
          }));
        }
      }

      for (const [feeType, fees] of feesByType) {
        if (fees.length > 1) {
          errors.push(error('duplicate-fee', kaT('kawaii.js.cart_components_cart_err_duplicate_html', '同じギフト料金が重複しています。カートをご確認ください。'), token, { feeType }));
        }
      }

      const required = requiredFeeTypes(props(main));
      for (const feeType of required) {
        if (!feesByType.has(feeType)) {
          const label = feeType === 'wrapping' ? 'ラッピング' : 'アートのし';
          errors.push(error('missing-fee', kaT.on() ? kaT('kawaii.js.cart_missing_fee_html', 'The fee for [label] is missing from your cart. Please check your selections.').replace('[label]', kaT.val(label)) : `${label}の料金がカートにありません。選択内容をご確認ください。`, token, { feeType }));
        }
      }
      for (const [feeType, fees] of feesByType) {
        if (!required.includes(feeType)) {
          for (const fee of fees) {
            errors.push(error('unexpected-fee', kaT('kawaii.js.cart_components_cart_err_unexpected_html', '選択されていないギフト料金がカートに残っています。カートをご確認ください。'), token, {
              key: fee.key,
              feeType
            }));
          }
        }
      }
    }

    return { groups, orphanFees, errors };
  }

  function uniqueMain(items, mainKey) {
    const matches = (items || []).filter((item) => item && item.key === mainKey && tagged(item, 'main'));
    if (matches.length !== 1) throw new Error('Gift main line was not found or is ambiguous.');
    return matches[0];
  }

  function planQuantity(items, mainKey, quantity) {
    if (!Number.isInteger(quantity) || quantity < 0) throw new RangeError('Gift quantity must be an integer greater than or equal to zero.');
    const main = uniqueMain(items, mainKey);
    const token = props(main)[TOKEN];
    const tokenMains = (items || []).filter((item) => tagged(item, 'main') && props(item)[TOKEN] === token);
    if (tokenMains.length !== 1) throw new Error('Gift main token is ambiguous.');
    const updates = { [main.key]: quantity };
    for (const item of items || []) {
      if (tagged(item, 'fee') && props(item)[TOKEN] === token) updates[item.key] = quantity;
    }
    return updates;
  }

  function planRemoveFee(items, feeKey) {
    const fees = (items || []).filter((item) => item && item.key === feeKey && tagged(item, 'fee'));
    if (fees.length !== 1) throw new Error('Gift fee line was not found or is ambiguous.');
    const fee = fees[0];
    const feeProperties = props(fee);
    const mains = (items || []).filter((item) => tagged(item, 'main') && props(item)[TOKEN] === feeProperties[TOKEN]);
    if (mains.length !== 1) throw new Error('Associated gift main line was not found or is ambiguous.');

    const main = mains[0];
    const properties = Object.assign({}, props(main));
    if (feeProperties[FEE_TYPE] === 'wrapping') {
      properties['ラッピング'] = 'ラッピングなし';
    } else if (feeProperties[FEE_TYPE] === 'art-noshi') {
      properties['のし'] = 'のしなし';
      delete properties['のしの記載内容'];
    } else {
      throw new Error('Unsupported gift fee type.');
    }

    return { mainKey: main.key, properties, updates: { [fee.key]: 0 } };
  }

  return { analyze, planQuantity, planRemoveFee };
});


// KAWAII ART: keep optional service lines tied to their artwork.
(() => {
  const core = globalThis.KaGiftCore;
  const originalChange = Cart.change.bind(Cart);
  let busy = false, scheduled = false, replayClick = false;
  const message = kaT('kawaii.js.cart_components_cart_err_mismatch_html', 'ラッピング・のしの指定と料金が一致していません。該当作品をカートから削除し、商品ページで選び直してください。');
  const money = cents => new Intl.NumberFormat('ja-JP', {style:'currency',currency:Cart.getState().cart.currency || 'JPY'}).format(cents / 100);
  const stateItems = () => Cart.getState().cart.items || [];
  const quantityPending = () => [...document.querySelectorAll('cart-item')].some(row=>{
    const item=stateItems().find(i=>i.key===row.getAttribute('key'));
    const input=row.querySelector('quantity-input input');
    return item?.properties?._dn13_gift_token && input && Number(input.value)!==item.quantity;
  });
  const notify = text => { window.alert(text); };
  const schedule = () => { if (!scheduled) { scheduled = true; requestAnimationFrame(() => { scheduled=false; render(); }); } };
  const transaction = async action => {
    if (busy) { notify(kaT('kawaii.js.cart_components_cart_busy_html', '更新中です。少し待ってから操作してください。')); return Cart.getState().cart; }
    busy=true; schedule();
    try { return await action(); }
    catch (error) { notify(kaT('kawaii.js.cart_components_cart_update_failed_html', 'カートを更新できませんでした。再読み込みして内容をご確認ください。')); try { await Cart.refresh(); } catch {} return Cart.getState().cart; }
    finally { busy=false; schedule(); }
  };
  Cart.change = async request => {
    const items=stateItems();
    const item=items.find(i=>i.key===request.id);
    if (!item?.properties?._dn13_gift_token || request.properties) return originalChange(request);
    const role=item.properties._dn13_gift_role;
    if (role==='fee') {
      if (Number(request.quantity)!==0) { schedule(); return Cart.getState().cart; }
      if (!items.some(i=>i.properties?._dn13_gift_role==='main' && i.properties?._dn13_gift_token===item.properties._dn13_gift_token)) return transaction(()=>originalChange(request));
      const type=item.properties._dn13_gift_fee_type;
      if (!window.confirm(type==='wrapping' ? kaT('kawaii.js.cart_components_cart_confirm_wrap_html', 'この作品のラッピングを無しにしますか？') : kaT('kawaii.js.cart_components_cart_confirm_noshi_html', 'この作品のアートのしを無しにしますか？'))) { schedule(); return Cart.getState().cart; }
      return transaction(async()=>{
        const plan=core.planRemoveFee(stateItems(),item.key);
        const main=stateItems().find(i=>i.key===plan.mainKey);
        // Change the selection first. If the second request fails, the mismatch guard blocks checkout.
        await originalChange({id:plan.mainKey,quantity:main.quantity,properties:plan.properties});
        return await Cart.update({updates:plan.updates},'kaGiftRemoval');
      });
    }
    if (role==='main') return transaction(()=>Cart.update({updates:core.planQuantity(stateItems(),item.key,Number(request.quantity))},'kaGiftQuantity'));
    return originalChange(request);
  };
  const style=document.createElement('style');
  style.textContent=`cart-item[data-ka-gift-fee]{display:none!important}.ka-gift-summary{margin-top:12px;padding:12px;background:#faf8f5;border-radius:6px;font-size:16px;line-height:1.6}.ka-gift-summary p{margin:0 0 6px}.ka-gift-summary .ka-gift-fee-row{display:flex;flex-wrap:wrap;align-items:center;gap:4px 12px;margin:0 0 8px}.ka-gift-summary .ka-gift-fee-row p{flex:1 1 210px;min-width:0;margin:0;overflow-wrap:anywhere}.ka-gift-summary .ka-gift-fee-remove{display:inline-flex;align-items:center;justify-content:center;flex:0 0 auto;width:auto;height:auto;min-height:44px;padding:4px 10px;margin:0;background:#fff;border:1px solid #a59b94;border-radius:4px;color:#514a45;font-family:inherit;font-size:14px;font-weight:400;line-height:1.4;letter-spacing:normal;white-space:nowrap;text-transform:none;cursor:pointer}.ka-gift-summary .ka-gift-fee-remove:hover{background:#f0ece7}.ka-gift-summary .ka-gift-fee-remove:focus-visible{outline:2px solid #5c514c;outline-offset:2px}@media(max-width:749px){.cart-item__details>.ka-gift-summary{grid-column:1 / -1;min-width:0}.ka-gift-summary .ka-gift-fee-row{display:block}.ka-gift-summary .ka-gift-fee-remove{margin-top:4px}}.ka-gift-summary strong{display:block;border-top:1px solid #ddd;padding-top:8px}.ka-gift-warning{font-size:16px;line-height:1.6;padding:12px;border:1px solid #a94432;color:#762719;background:#fff7f4;margin:12px 0}body[data-ka-gift-busy] cart-item button,body[data-ka-gift-busy] cart-item input,body[data-ka-gift-busy] cart-item a[cart-item-remove]{pointer-events:none;opacity:.6}`;
  document.head.append(style);
  function render() {
    const items=stateItems(), analysis=core.analyze(items);
    document.body.toggleAttribute('data-ka-gift-busy',busy);
    document.querySelectorAll('cart-item').forEach(row=>{
      const item=items.find(i=>i.key===row.getAttribute('key'));
      if (!item) return;
      const group=analysis.groups.find(g=>g.main?.key===item.key);
      const linkedFee=analysis.groups.some(g=>g.main && g.fees.some(f=>f.key===item.key));
      row.toggleAttribute('data-ka-gift-fee',linkedFee);
      const frameOption=item.options_with_values?.find(option=>option.name==='額縁'||option.name==='額の種類')?.value;
      const frameLabel=frameOption==='白'?kaT.val('ホワイト(木目調)'):frameOption==='ブラウン'?kaT.val('ブラウン(木目調)'):(kaT.on()&&frameOption?kaT.val(frameOption):null);
      const variantValue=row.querySelector('cart-item-default-property property-value');
      if(frameLabel&&variantValue&&item.variant_title){
        const parts=item.variant_title.split(' / ');
        if(parts[parts.length-1]===frameOption){
          parts[parts.length-1]=frameLabel;
          variantValue.textContent=parts.join(' / ');
        }
      }
      if (linkedFee) row.querySelectorAll('quantity-input input').forEach(input=>{input.value=item.quantity;});
      let summary=row.querySelector('.ka-gift-summary');
      if (!group || !group.fees.length) { summary?.remove(); return; }
      if (!summary) { summary=document.createElement('div');summary.className='ka-gift-summary'; row.querySelector('cart-item-details')?.append(summary); }
      summary.replaceChildren();
      const base=document.createElement('p');base.textContent=kaT('kawaii.js.cart_components_cart_artwork_html', '作品：')+money(item.final_line_price);summary.append(base);
      group.fees.forEach(fee=>{
        const feeRow=document.createElement('div');feeRow.className='ka-gift-fee-row';
        const label=document.createElement('p'); label.textContent=kaT.on() ? ((fee.properties._dn13_gift_fee_type==='wrapping' ? kaT('kawaii.js.cart_gift_wrap_html', 'Gift wrap: [v]').replace('[v]', kaT.val(fee.variant_title || fee.title)) : kaT('kawaii.js.cart_art_noshi_html', 'Art noshi'))+' '+money(fee.final_line_price)+' (×'+fee.quantity+')') : (fee.properties._dn13_gift_fee_type==='wrapping' ? 'ラッピング：'+(fee.variant_title || fee.title) : 'アートのし')+'　'+money(fee.final_line_price)+'（'+fee.quantity+'点）';
        const remove=document.createElement('button');remove.type='button';remove.className='ka-gift-fee-remove';
        const removeLabel=fee.properties._dn13_gift_fee_type==='wrapping'?kaT('kawaii.js.cart_components_cart_remove_wrap_html', 'ラッピングを削除'):kaT('kawaii.js.cart_components_cart_remove_noshi_html', 'のしを削除');
        remove.setAttribute('aria-label',removeLabel);remove.title=removeLabel;
        remove.textContent=removeLabel;
        remove.disabled=busy;remove.addEventListener('click',()=>Cart.change({id:fee.key,quantity:0}));
        feeRow.append(label,remove);summary.append(feeRow);
      });
      const total=document.createElement('strong');total.textContent=kaT('kawaii.js.cart_components_cart_artwork_total_html', 'この作品の合計：')+money(item.final_line_price+group.fees.reduce((s,f)=>s+f.final_line_price,0));summary.append(total);
    });
    document.querySelectorAll('button[name="checkout"]').forEach(button=>{
      let warning=button.parentElement.querySelector('.ka-gift-warning');
      if (analysis.errors.length) { if(!warning){warning=document.createElement('div');warning.className='ka-gift-warning';warning.setAttribute('role','alert');button.before(warning);}warning.textContent=message; }
      else warning?.remove();
      button.setAttribute('aria-busy',String(busy));
    });
  }
  async function checkCheckout(event) {
    if (event.type==='submit') {
      const form=event.target;
      if (!form?.querySelector?.('button[name="checkout"]')) return;
      // Runs again on the note/attribute saver's requestSubmit replay.
      // Never grant a timed bypass across a service mutation.
      if (busy || quantityPending() || core.analyze(stateItems()).errors.length) {
        event.preventDefault();event.stopImmediatePropagation();
        notify(busy || quantityPending() ? kaT('kawaii.js.cart_components_cart_wait_checkout_html', 'カートの更新が完了してから、もう一度レジへお進みください。') : message);
      }
      return;
    }
    const button=event.type==='click' ? event.target.closest?.('button[name="checkout"],a[href*="/checkout"]') : event.submitter;
    if (!button) return;
    if (replayClick) { replayClick=false;return; }
    event.preventDefault();event.stopImmediatePropagation();
    if (busy || quantityPending()) { notify(kaT('kawaii.js.cart_components_cart_wait_checkout_html', 'カートの更新が完了してから、もう一度レジへお進みください。')); return; }
    busy=true;schedule();
    try {
      const cart=await Cart.refresh();
      if (core.analyze(cart.items || []).errors.length) { notify(message);return; }
      busy=false;replayClick=true;
      try { button.click(); } finally { replayClick=false; }
    } catch { notify(kaT('kawaii.js.cart_components_cart_check_failed_html', 'カートを確認できませんでした。もう一度お試しください。')); }
    finally {busy=false;schedule();}
  }
  document.addEventListener('click',checkCheckout,true);
  document.addEventListener('submit',checkCheckout,true);
  Cart.subscribe(schedule);
  document.addEventListener('shopify:section:load',schedule);
  schedule();
})();

// KAWAII ART: resync the cart display after browser history restores old HTML.
(() => {
  // 9/24：カート画面だけでなく全ページで行う（カートの引き出し・上部の数も古いまま復元されるため）
  let initialShowHandled = false;
  let pending = false;
  const syncHistoryCart = async (event) => {
    if (!event.persisted) {
      if (initialShowHandled) return;
      initialShowHandled = true;
      const navigation = window.performance?.getEntriesByType?.('navigation')?.[0];
      if (navigation?.type !== 'back_forward') return;
    }
    if (pending) return;
    pending = true;
    const region = document.querySelector('interactive-cart');
    const wasInert = region?.inert;
    if (region) region.inert = true;
    try {
      await Cart.refresh();
      document.getElementById('ka-cart-history-error')?.remove();
    } catch (error) {
      if (!document.getElementById('ka-cart-history-error') && region) {
        const notice = document.createElement('p');
        notice.id = 'ka-cart-history-error';
        notice.setAttribute('role', 'alert');
        notice.textContent = kaT('kawaii.js.cart_components_cart_refresh_failed_html', 'カートの最新情報を取得できませんでした。再読み込みして内容をご確認ください。');
        region.before(notice);
      }
      console.warn('Cart history refresh failed', error);
    } finally {
      if (region) region.inert = wasInert;
      pending = false;
    }
  };
  window.addEventListener('pageshow', syncHistoryCart);
  // Module scripts can arrive after pageshow; handle that case without two refreshes.
  if (document.readyState === 'complete') syncHistoryCart({ persisted: false });
})();

export { CartItem, InteractiveCart };
//# sourceMappingURL=cart-components.js.map
